(function () {
  'use strict';

  function pushToDataLayer(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }

  function shopifyRoute(path) {
    var root = '/';

    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      root = window.Shopify.routes.root;
    }

    return root + path;
  }

  function initRitualSection(section) {
    if (!section || section.getAttribute('data-tc-initialized') === 'true') {
      return;
    }

    section.setAttribute('data-tc-initialized', 'true');

    var isEnglish = document.documentElement.lang.toLowerCase().split('-')[0] === 'en';
    var toast = section.querySelector('.tc-toast');
    var toastTimer = null;
    var reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function announce(message, isError) {
      if (!toast) {
        return;
      }

      window.clearTimeout(toastTimer);
      toast.textContent = message;
      toast.classList.toggle('is-error', Boolean(isError));
      toast.classList.add('is-visible');

      toastTimer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
      }, isError ? 6000 : 4000);
    }

    var finderButtons = section.querySelectorAll('[data-ritual-target]');

    var stepDisclosures = section.querySelectorAll('.tc-steps-disclosure');
    var mobileLayout = window.matchMedia
      ? window.matchMedia('(max-width: 749px)')
      : null;

    Array.prototype.forEach.call(stepDisclosures, function (details) {
      if (mobileLayout && mobileLayout.matches) {
        details.removeAttribute('open');
      } else {
        details.setAttribute('open', '');
      }
    });

    Array.prototype.forEach.call(finderButtons, function (button) {
      button.addEventListener('click', function () {
        var targetId = button.getAttribute('data-ritual-target') || '';
        var normalizedTargetId = targetId.replace(/^#/, '');
        var target = normalizedTargetId
          ? document.getElementById(normalizedTargetId) ||
            document.getElementById('rituel-' + normalizedTargetId)
          : null;

        Array.prototype.forEach.call(finderButtons, function (item) {
          var isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        pushToDataLayer({
          event: 'ritual_finder_select',
          ritual_id: targetId || ''
        });

        if (target) {
          target.scrollIntoView({
            behavior: reduceMotion ? 'auto' : 'smooth',
            block: 'start'
          });
        }
      });
    });

    var addButtons = section.querySelectorAll('.tc-add-ritual');

    Array.prototype.forEach.call(addButtons, function (button) {
      button.addEventListener('click', async function () {
        if (button.disabled || button.getAttribute('aria-busy') === 'true') {
          return;
        }

        var ritualId =
          button.getAttribute('data-ritual') ||
          button.getAttribute('data-ritual-id') ||
          '';
        var variantAttribute = button.getAttribute('data-variants') || '';
        var variantIds = variantAttribute
          .split(',')
          .map(function (id) {
            return id.trim();
          })
          .filter(function (id) {
            return /^\d+$/.test(id) && Number(id) > 0;
          });

        if (!variantIds.length) {
          announce(
            (isEnglish ? 'This ritual is temporarily unavailable. Please choose another ritual.' : 'Ce rituel n\u2019est pas encore configur\u00e9. S\u00e9lectionnez ses produits dans l\u2019\u00e9diteur de th\u00e8me Shopify.'),
            true
          );

          pushToDataLayer({
            event: 'ritual_add_all_error',
            ritual_id: ritualId,
            error_type: 'missing_variants'
          });
          return;
        }

        var originalHtml = button.innerHTML;
        var cartComponent =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        var sectionIds = [];

        if (
          cartComponent &&
          typeof cartComponent.getSectionsToRender === 'function'
        ) {
          sectionIds = cartComponent
            .getSectionsToRender()
            .map(function (item) {
              return item.id;
            })
            .filter(Boolean);
        }

        var requestBody = {
          items: variantIds.map(function (id) {
            return {
              id: Number(id),
              quantity: 1,
              properties: {
                '_Rituel Tonsor': ritualId
              }
            };
          })
        };

        if (sectionIds.length) {
          requestBody.sections = sectionIds;
          requestBody.sections_url = window.location.pathname;
        }

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = (isEnglish ? 'Adding to cart\u2026' : 'Ajout en cours\u2026');

        pushToDataLayer({
          event: 'ritual_add_all',
          ritual_id: ritualId,
          variant_ids: variantIds,
          product_count: variantIds.length
        });

        try {
          var response = await fetch(shopifyRoute('cart/add.js'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify(requestBody)
          });

          var data = {};

          try {
            data = await response.json();
          } catch (jsonError) {
            data = {};
          }

          if (!response.ok) {
            throw new Error(
              data.description ||
                data.message ||
                (isEnglish ? 'The products could not be added to your cart.' : 'Shopify n\u2019a pas pu ajouter les produits.')
            );
          }

          pushToDataLayer({
            event: 'ritual_add_all_success',
            ritual_id: ritualId,
            variant_ids: variantIds,
            product_count: variantIds.length
          });

          announce(
            variantIds.length > 1
              ? (isEnglish ? 'The ritual has been added to your cart.' : 'Le rituel a bien \u00e9t\u00e9 ajout\u00e9 au panier.')
              : (isEnglish ? 'The product has been added to your cart.' : 'Le produit a bien \u00e9t\u00e9 ajout\u00e9 au panier.'),
            false
          );

          var cartRendered = false;

          if (
            cartComponent &&
            typeof cartComponent.renderContents === 'function' &&
            data.sections
          ) {
            try {
              if (
                !data.key &&
                Array.isArray(data.items) &&
                data.items.length &&
                data.items[0].key
              ) {
                data.key = data.items[0].key;
              }

              cartComponent.renderContents(data);
              cartRendered = true;
            } catch (renderError) {
              console.warn(
                'Le panier a \u00e9t\u00e9 mis \u00e0 jour, mais son tiroir ne peut pas \u00eatre rafra\u00eechi automatiquement.',
                renderError
              );
            }
          }

          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: {
                source: 'rituels-conversion',
                ritualId: ritualId,
                response: data
              }
            })
          );

          if (!cartRendered) {
            window.setTimeout(function () {
              window.location.assign(shopifyRoute('cart'));
            }, 500);
          }
        } catch (error) {
          console.error('Erreur lors de l\u2019ajout du rituel :', error);

          announce(
            error && error.message
              ? error.message
              : (isEnglish ? 'Unable to add to cart. Please try again.' : 'Ajout impossible. Veuillez r\u00e9essayer.'),
            true
          );

          pushToDataLayer({
            event: 'ritual_add_all_error',
            ritual_id: ritualId,
            error_message:
              error && error.message ? error.message : 'unknown_error'
          });
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.innerHTML = originalHtml;
        }
      });
    });

    var ritualModules = section.querySelectorAll('[data-ritual-id]');

    if ('IntersectionObserver' in window) {
      var viewedRituals = {};
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            var ritualId = entry.target.getAttribute('data-ritual-id') || '';

            if (!ritualId || viewedRituals[ritualId]) {
              return;
            }

            viewedRituals[ritualId] = true;
            pushToDataLayer({
              event: 'ritual_module_view',
              ritual_id: ritualId
            });
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.35 }
      );

      Array.prototype.forEach.call(ritualModules, function (module) {
        observer.observe(module);
      });
    }

    var faqItems = section.querySelectorAll('.tc-faq details');

    Array.prototype.forEach.call(faqItems, function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) {
          return;
        }

        var summary = item.querySelector('summary');

        pushToDataLayer({
          event: 'ritual_faq_open',
          faq_title: summary ? summary.textContent.trim() : ''
        });
      });
    });
  }

  function initAll(context) {
    var scope = context || document;

    if (scope.matches && scope.matches('.tc-rituels')) {
      initRitualSection(scope);
    }

    if (!scope.querySelectorAll) {
      return;
    }

    var sections = scope.querySelectorAll('.tc-rituels');

    Array.prototype.forEach.call(sections, function (section) {
      initRitualSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
